export type ExtractionSignalFlags = {
  isCytology: boolean;
  isResearch: boolean;
  isConsultation: boolean;
  isTcOnly: boolean;
};

type ExtractionResultWithSignals = {
  signals?: Partial<Record<keyof ExtractionSignalFlags, unknown>>;
};

export function readExtractionSignalFlags(
  result: ExtractionResultWithSignals | null | undefined
): ExtractionSignalFlags | null {
  const signals = result?.signals;
  if (!signals) return null;

  return {
    isCytology: signals.isCytology === true,
    isResearch: signals.isResearch === true,
    isConsultation: signals.isConsultation === true,
    isTcOnly: signals.isTcOnly === true,
  };
}
